import { Component, computed, inject, input, LOCALE_ID, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-filter-price-range-input',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './filter-price-range-input.html',
})
export class FilterPriceRangeInput {
  private locale = inject(LOCALE_ID);

  label = input.required<string>();
  minVal = model<number | null>(null);
  maxVal = model<number | null>(null);
  minPlaceholder = input<string>('الحد الأدنى');
  maxPlaceholder = input<string>('الحد الأقصى');

  isArabic = computed(() => this.locale.startsWith('ar'));
}
